import React from 'react';

const NotFoundPages = () => {
    return (
        <div>
            <h3>404 Error</h3> 
            <h4>Page not found</h4>
        </div>
    );
};

export default NotFoundPages;